export default __webpack_public_path__ + "static/media/members-share.837bd598.jpg";